import { ChevronRight } from 'lucide-react';
import type { ComponentPropsWithoutRef, ReactNode, Ref } from 'react';
import { cx } from '../../utils/cx';
import { Icon } from '../Icon/Icon';
import s from './ChoiceCard.module.css';

export type ChoiceCardProps = Omit<ComponentPropsWithoutRef<'button'>, 'title'> & {
  ref?: Ref<HTMLButtonElement>;
  /** Emoji, icon, or small illustration. Decorative. */
  art?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
};

/** A big tappable choice ("Start a family" / "Join a family", the empty-list options). */
export function ChoiceCard({ art, title, description, className, type, ...rest }: ChoiceCardProps) {
  return (
    <button type={type ?? 'button'} className={cx(s.card, className)} {...rest}>
      {art ? (
        <span className={s.art} aria-hidden="true">
          {art}
        </span>
      ) : null}
      <span className={s.text}>
        <span className={s.title}>{title}</span>
        {description ? <span className={s.description}>{description}</span> : null}
      </span>
      <Icon icon={ChevronRight} size="md" className={s.chevron} />
    </button>
  );
}
